// extracted by mini-css-extract-plugin
export default {"BackgroundCubes":"styles_BackgroundCubes__G0dmQ","cube":"styles_cube__CcZtb","left":"styles_left__q4KYb","right":"styles_right__N+pZx"};